const VacancyTypeCreate = () =>
	import(
		/* webpackChunkName: "vacancytypecreate"*/ "@/views/VacancyTypeCreate.vue"
	);
const VacancyTypeEdit = () =>
	import(
		/* webpackChunkName: "vacancytypeedit"*/ "@/views/VacancyTypeEdit.vue"
	);

export default [
	{
		path: "listings/facility/:id/vacancy/:vacancyid/edit/",
		name: "VacancyTypeEdit",
		component: VacancyTypeEdit,
		meta: {
			title: "DailyAdmin - Vacancy edit"
		}
	},
	{
		path: "listings/facility/:id/vacancy/create/",
		name: "ListingsCreateVacancy",
		component: VacancyTypeCreate,
		meta: {
			title: "DailyAdmin - Vacancy create"
		}
	}
];
